<template>
  <d-form-row class="mt-4 mb-1">
    <d-col>
      <h5>{{ title }}</h5>
      <table class="table table-striped table-bordered" role="table" v-if="model">
        <thead class="bg-light" role="rowgroup">
          <tr role="row">
            <th role="columnheader" class="text-center">ID</th>
            <th role="columnheader">Descrição</th>
            <th role="columnheader" class="text-center">Qtd.</th>
            <th role="columnheader" class="text-right">Valor un.</th>
            <th role="columnheader" class="text-right">Total</th>
            <th role="columnheader" class="text-right"></th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <tr role="row" v-for="(item, index) in model" :key="index">
            <td role="cell" class="td-1">
              <span class="mt-2 text-center d-block">{{ index + 1 }}</span>
            </td>
            <td role="cell" class="td-6">
              <autocomplete
                :ref="`autocomplete_${slug}_${index}`"
                placeholder="Descrição"
                :items="items"
                item-show="name"
                :parameter="{ item, index }"
                :on-input="onInput"
                :on-select="onSelect"
                showIconClear
              />
            </td>
            <td role="cell" class="td-3">
              <input
                type="number"
                class="text-center form-control"
                placeholder="Qtd."
                v-model="item.quantity"
                @change="setQuantity(item)"
                required
              />
            </td>
            <td role="cell" class="td-4">
              <d-input-group prepend="R$">
                <input-currency
                  model-index="value"
                  placeholder="Valor"
                  :model="item"
                  :on-change="setTotal"
                />
              </d-input-group>
            </td>
            <td role="cell" class="td-4">
              <d-input-group prepend="R$">
                <input-currency
                  model-index="total"
                  placeholder="Total"
                  :model="item"
                  :on-change="setUnitValor"
                />
              </d-input-group>
            </td>
            <td role="cell" class="td-1 td">
              <div class="buttons">
                <i class="fas fa-plus text-success" @click="addRow(slug)" v-if="index + 1 === model.length"></i>
                <i class="fas fa-minus text-danger" @click="removeRow(index, slug)" v-if="model.length > 1"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </d-col>
  </d-form-row>
</template>

<script>
import Autocomplete from '_shared/Autocomplete.vue';
import InputCurrency from '_shared/InputCurrency.vue';

export default {
  name: 'quotation-other-items-table',
  props: {
    title: { type: String, required: true },
    slug: { type: String, required: true },
    model: { type: Array, required: true },
    items: { type: Array, required: true },
    addRow: { type: Function, required: true },
    removeRow: { type: Function, required: true },
    onInput: { type: Function, required: true },
    onSelect: { type: Function, required: true },
    setQuantity: { type: Function, required: true },
    setTotal: { type: Function, required: true },
    setUnitValor: { type: Function, required: true },
  },
  components: {
    Autocomplete,
    InputCurrency,
  },
  methods: {
    setAutocompleteValues() {
      this.model.forEach((row, index) => {
        const refName = `autocomplete_${this.slug}_${index}`;
        const autocomplete = this.$refs[refName];
        const input = autocomplete[0]?.$refs?.input;

        if (input && row.product?.name) {
          input.value = row.product.name;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';
@import '~_scss/table';
</style>
